(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9242,1521,2794],{

/***/ 41282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgZoom = function SvgZoom(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    y: 0.293,
    width: 32,
    height: 32,
    rx: 5,
    fill: "#025754"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.539 24.465H24v-7.462h-1.59v4.498l-4.498-4.498-1.373 1.373 4.498 4.499h-4.498v1.59ZM15.461 8.293H8v7.462h1.59v-4.499l4.498 4.499 1.373-1.374-4.498-4.498h4.498v-1.59Z",
    fill: "#fff"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgZoom);

/***/ }),

/***/ 41521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDerechaSinBorde = function SvgDerechaSinBorde(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 134 134"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: 66.581,
    cy: 66.653,
    rx: 64.01,
    ry: 64.438,
    style: {
      fill: "#fff",
      stroke: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M58.333 50 75 66.667 58.333 83.333",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: "6.67px",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4
    }
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgDerechaSinBorde);

/***/ }),

/***/ 62794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIzquierdaSinBorde = function SvgIzquierdaSinBorde(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 134 134"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: 66.581,
    cy: 66.653,
    rx: 64.01,
    ry: 64.438,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M75 50 58.333 66.667 75 83.333",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: "6.67px"
    }
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgIzquierdaSinBorde);

/***/ }),

/***/ 2875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ multimedia_Galeria; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(43203);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(9434);
// EXTERNAL MODULE: ./public/assets/domainBrand/zoom.svg
var zoom = __webpack_require__(41282);
// EXTERNAL MODULE: ./public/assets/icons/DerechaSinBorde.svg
var DerechaSinBorde = __webpack_require__(41521);
// EXTERNAL MODULE: ./public/assets/icons/IzquierdaSinBorde.svg
var IzquierdaSinBorde = __webpack_require__(62794);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(25194);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination.css
var pagination = __webpack_require__(18700);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation.css
var navigation = __webpack_require__(94375);
;// CONCATENATED MODULE: ./components/atoms/multimedia/Galeria/Galeria.tsx












var PopUpGaleria = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(6402)]).then(__webpack_require__.bind(__webpack_require__, 46402));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46402)
            ];
        }
    },
    ssr: false
});
/**
 * Galeria
 */ var Galeria = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _images = param.images, images = _images === void 0 ? [] : _images, heigth = param.heigth, _roundedPosition = param.roundedPosition, roundedPosition = _roundedPosition === void 0 ? "top" : _roundedPosition, title = param.title, desc = param.desc;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var showGallery = function() {
        setOpen(!open);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpGaleria, {
                title: title,
                images: images,
                setState: setOpen,
                state: open,
                desc: desc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: roundedPosition === "top" ? heigth ? "".concat(heigth, "px") : "auto" : "100%"
                },
                className: className,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    slidesPerView: 1,
                    navigation: {
                        nextEl: ".Siguiente",
                        prevEl: ".Anterior"
                    },
                    modules: [
                        modules/* Pagination */.tl,
                        modules/* Navigation */.W_
                    ],
                    pagination: {
                        dynamicBullets: true,
                        clickable: true
                    },
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    className: roundedPosition === "top" ? "rounded-t-md" : roundedPosition === "left" ? "rounded-r-md" : roundedPosition === "all" ? "rounded-md" : "",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute right-2 top-2 z-10 h-8 w-8 cursor-pointer",
                            onClick: showGallery,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zoom/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute top-1/2 z-20 flex w-full -translate-y-1/2 flex-row items-center justify-between px-2 text-primary-400",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IzquierdaSinBorde["default"], {
                                    width: 30,
                                    className: "Anterior cursor-pointer",
                                    role: "button"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DerechaSinBorde["default"], {
                                    width: 30,
                                    className: "Siguiente cursor-pointer",
                                    role: "button"
                                })
                            ]
                        }),
                        images === null || images === void 0 ? void 0 : images.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                style: {
                                    transform: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative h-full w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item,
                                        objectFit: "cover",
                                        layout: "fill",
                                        alt: "image of card"
                                    })
                                })
                            }, index);
                        })
                    ]
                })
            })
        ]
    });
};
Galeria.displayName = "Galeria";

;// CONCATENATED MODULE: ./components/atoms/multimedia/Galeria/index.ts

/* harmony default export */ var multimedia_Galeria = (Galeria);


/***/ }),

/***/ 18700:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);